import React from 'react'
import Story from './Story'
import "./StoryReel.css"

function StoryReel() {
    return (

        <div className="StoryReel">
            <Story title="uvislive" image="images/1.jpeg" profilesrc="images/uv.png" />
            <Story title="ajaysinh" image="images/2.jpg" profilesrc="" />
            <Story title="vishal" image="images/3.jpg" />
            <Story title="dhruvil" image="images/4.jpg" profilesrc="" />
            <Story title="Rahul" image="images/5.jpg" profilesrc="" />
            <Story title="whitedevil" image="images/6.jpg" profilesrc="" />
            <Story title="ankurwarikoo" image="images/7.jpg" profilesrc="" />
            <Story title="sahil" image="images/7.jpg" profilesrc="" />
            <Story title="Hitesh" image="images/7.jpg" profilesrc="" />

        </div>


    )
}

export default StoryReel